/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerReportMarkdownQueryResponse, IncidentInvestigationControllerReportMarkdownPathParams, IncidentInvestigationControllerReportMarkdown400, IncidentInvestigationControllerReportMarkdown401, IncidentInvestigationControllerReportMarkdown403, IncidentInvestigationControllerReportMarkdown404, IncidentInvestigationControllerReportMarkdown409 } from "../../models/incidentAgentController/IncidentInvestigationControllerReportMarkdown";

function getIncidentInvestigationControllerReportMarkdownUrl(id: IncidentInvestigationControllerReportMarkdownPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/report/markdown` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/report/markdown}
 */
export async function incidentInvestigationControllerReportMarkdown(id: IncidentInvestigationControllerReportMarkdownPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerReportMarkdownQueryResponse, ResponseErrorConfig<IncidentInvestigationControllerReportMarkdown400 | IncidentInvestigationControllerReportMarkdown401 | IncidentInvestigationControllerReportMarkdown403 | IncidentInvestigationControllerReportMarkdown404 | IncidentInvestigationControllerReportMarkdown409>, unknown>({ method : "GET", url : getIncidentInvestigationControllerReportMarkdownUrl(id).url.toString(), ... requestConfig })  
  return res.data
}